import { type RouteObject, RouterProvider, createBrowserRouter, useParams } from 'react-router-dom';
import { ErrorPage } from 'src/components/ErrorPage';
import { PlayerView } from 'src/views/PlayerView';

const elevationChartRoutes: Array<RouteObject> = [
  {
    path: '/player/:eventSlug',
    element: <PlayerView />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/player',
    element: <ErrorPage />,
    errorElement: <ErrorPage />,
  },
];

const router = createBrowserRouter(elevationChartRoutes);

export const PlayerRouter = () => {
  return <RouterProvider router={router} />;
};

export const usePlayerParams = (): Readonly<Partial<{ eventSlug: string }>> => {
  return useParams<{ eventSlug: string }>();
};
